<template>
  <v-row
    class="d-flex  my-6 mx-2"
    justify="start"
    align="start"
    @click="$emit('selectorderProduct', orderProduct)"
  >
    <v-row class="fill-width" no-gutters style="width: -webkit-fill-available;">
      <v-col v-if="removable" cols="1">
        <v-icon @click.stop.prevent="removeOrderProduct" color="primary">
          mdi-close
        </v-icon>
      </v-col>
      <v-col :cols="removable ? 8 : 9">
        <div :class="{ 'body-1': true, 'grey--text': hasBeenPaid }">
          {{ orderProduct.name }}
        </div>
      </v-col>
      <v-col cols="3" class="text-right">
        <div
          class="body-2 align-content-start"
          align-self="top"
          v-if="orderProduct.price > 0"
        >
          {{ localizedPrice(orderProduct.price) }}
        </div>
      </v-col>
    </v-row>
    <v-row
      no-gutters
      :class="{
        caption: true,
        'grey--text': true,
        'text--darken-1': !isDark,
        'text--lighten-1': isDark
      }"
    >
      <v-col v-if="removable" cols="1"> </v-col>
      <v-col :cols="removable ? 8 : 9">
        <div v-for="(option, index) in orderProduct.options" :key="index">
          {{ option.name }}
        </div>
        <div
          style=" font-style: italic;"
          :class="{
            caption: true,
            'grey--text': true,
            'text--darken-1': !isDark,
            'text--lighten-1': isDark
          }"
        >
          {{ orderProduct.comment }}
        </div>
      </v-col>
      <v-col cols="3" class="text-right">
        <div
          class="body-2 align-text-end"
          v-for="(option, index) in orderProduct.options"
          :key="index"
          align-text="bottom"
        >
          {{ localizedPrice(option.addedPrice) }}
        </div>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
export default {
  props: {
    orderProduct: {},
    removable: { default: true },
    hasBeenPaid: { default: false }
  },
  computed: {
    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  },

  methods: {
    localizedPrice(price) {
      // TODO actually localize
      return parseFloat(price).toFixed(2) + " €";
    },
    removeOrderProduct() {
      this.$emit("removeOrderProduct", this.orderProduct);
    }
  }
};
</script>

<style scoped>
.background-dark {
  background-color: #1e1e1e !important;
}
.background-light {
  background-color: white !important;
}
</style>
